import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import React from 'react';
import { PreapprovalGroupedTrades } from '../store/types';
import AssetSummary from './assetSummary';

interface Props {
  groupedTrades: PreapprovalGroupedTrades[];
}

export default function AssetsSummary(props: Props): JSX.Element {
  const { groupedTrades } = props;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell variant={'body'}>
              <Typography variant="h3" color={'primary'}>
                Summary
              </Typography>
            </TableCell>
            <TableCell variant={'body'} align="left"></TableCell>
            <TableCell variant={'body'} align="left"></TableCell>
          </TableRow>
          <TableRow>
            <TableCell variant={'head'}>
              <Typography variant="h6" color="textSecondary">
                ASSET CLASS
              </Typography>
            </TableCell>
            <TableCell variant={'head'} align="center">
              <Typography variant="h6" color="textSecondary">
                ORDERS
              </Typography>
            </TableCell>
            <TableCell variant={'head'} align="right">
              <Typography variant="h6" color="textSecondary">
                VALUE
              </Typography>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {groupedTrades.map((groupedTrades, index: number) => (
            <AssetSummary key={index} groupedTrades={groupedTrades} index={index} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
